const ContactoForm = ({ contacto, errors, onChange }) => {
  const inputClass = (field) =>
    `w-full rounded-xl border bg-white px-3 py-2.5 text-sm text-slate-900 transition focus:border-red-400 focus:outline-none focus:ring-2 focus:ring-red-200 ${
      errors[`contactos.0.${field}`] ? 'border-red-500 ring-2 ring-red-100' : 'border-slate-300'
    }`;

  const handleTelChange = (e) => {
    const value = e.target.value.replace(/[^\d]/g, '');
    onChange(e.target.name, value);
  };

  return (
    <div className="ui-card p-5 md:p-6">
      <div className="mb-4 flex items-center gap-3 border-b border-slate-200 pb-3">
        <div className="h-8 w-1.5 rounded-full bg-red-600" />
        <h3 className="text-base font-semibold uppercase tracking-[0.08em] text-slate-800">DATOS DE CONTACTO</h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Teléfono principal */}
        <div>
          <label htmlFor="contacto-telefono" className="mb-1 block text-xs font-semibold uppercase tracking-[0.08em] text-slate-600">
            TELÉFONO
          </label>
          <input
            id="contacto-telefono"
            name="contacto.telefono"
            type="text"
            inputMode="numeric"
            autoComplete="tel"
            maxLength={9}
            placeholder="EJ: 987654321"
            value={contacto?.telefono || ''}
            onChange={handleTelChange}
            className={inputClass('telefono')}
          />
          {errors['contactos.0.telefono'] && (
            <p className="mt-1 text-xs font-medium text-red-600">{errors['contactos.0.telefono'][0]}</p>
          )}
        </div>
        {/* Teléfono 2 */}
        <div>
          <label htmlFor="contacto-telefonoDos" className="mb-1 block text-xs font-semibold uppercase tracking-[0.08em] text-slate-600">
            TELÉFONO 2 (OPCIONAL)
          </label>
          <input
            id="contacto-telefonoDos"
            name="contacto.telefonoDos"
            type="text"
            inputMode="numeric"
            autoComplete="tel"
            maxLength={9}
            placeholder="EJ: 912345678"
            value={contacto?.telefonoDos || ''}
            onChange={handleTelChange}
            className={inputClass('telefonoDos')}
          />
          {errors['contactos.0.telefonoDos'] && (
            <p className="mt-1 text-xs font-medium text-red-600">{errors['contactos.0.telefonoDos'][0]}</p>
          )}
        </div>
        {/* Email */}
        <div>
          <label htmlFor="contacto-email" className="mb-1 block text-xs font-semibold uppercase tracking-[0.08em] text-slate-600">
            EMAIL
          </label>
          <input
            id="contacto-email"
            name="contacto.email"
            type="email"
            autoComplete="email"
            placeholder="EJ: correo@ficsullana"
            value={contacto?.email || ''}
            onChange={(e) => onChange(e.target.name, e.target.value)}
            className={inputClass('email')}
            style={{ textTransform: 'lowercase' }}
          />
          {errors['contactos.0.email'] && (
            <p className="mt-1 text-xs font-medium text-red-600">{errors['contactos.0.email'][0]}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactoForm;
